import React from 'react'
import { CmsDynamicPage, CmsStaticPage } from 'crownpeak-dxm-react-sdk';
import DropZone from "../components/functional/dropZone";
import Routing from "../core/routing";
import SidebarTopHeader from '../components/global/sidebar-menu-header';
import SidebarTopImage from '../components/global/sidebar-menu-image';
import SidebarNavigation from '../components/global/sidebar-navigation';
import HeaderNavigation from '../components/global/header-navigation';
import FooterNavigation from '../components/global/footer-navigation';
import { Link, useLocation } from 'react-router-dom';

export default class KvgNotificationPage extends CmsStaticPage {
    state = {
        isLoaded: false,
        cmsAssetIdState: ''
    }

    constructor(props: any) {
        super(props);
        this.cmsSuppressFolder = true;
        this.cmsUseTmf = true;
        this.cmsWrapper = "Kverneland";
        this.cmsUseMetadata = true;
        this.cmsAssetId = Routing.getCmsAssetId(window.location.pathname);

        this.changeCols = this.changeCols.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        this.cmsAssetId = Routing.getCmsAssetId(window.location.pathname);
        if(prevState.isLoaded && prevState.cmsAssetIdState !== this.cmsAssetId) {
            this.setState({
                ...this.setState,
                isLoaded: false,
                cmsAssetIdState : this.cmsAssetId
            })
        }
    }

    

    changeCols() {
        let sidebarColumn = document.querySelector('#sidebarCol');
        let cardCol = document.querySelector('#largeCardCol');
        

        sidebarColumn?.classList.toggle('col-lg-3');
        sidebarColumn?.classList.toggle('col-lg-1');

        cardCol?.classList.toggle('col-lg-8');
        cardCol?.classList.toggle('col-lg-10');
    }
    render() {
        super.render();
        return (
            this.state.isLoaded &&
            <div className={window.localStorage.lang}>


                <header className="kvg-header header">
                    <HeaderNavigation dataProvider={this.cmsDataProvider} />
                </header>

                <main id="main-content" className="main-content" role="main" aria-label="main content">


                    <div className="cp-main-container kvg-wrapper">
                        <div className="container-fluid sidebar-wrapper">
                            <div className="row">
                                <div className="sidebar-wrapper-top-image">
                                    <SidebarTopImage dataProvider={this.cmsDataProvider} assetId={this.cmsAssetId} />
                                </div>
                                <div className="col-12 col-lg-3 d-none d-lg-block" id="sidebarCol">
                                    <div className="sidebar-menu-col">
                                        <div className="sidebar-menu show" id="sidebarMenu">
                                            <SidebarNavigation dataProvider={this.cmsDataProvider} />
                                        </div>
                                        <button id="sidebarToggler" className="sidebar-toggler" type="button" data-toggle="collapse" data-target="#sidebarMenu" aria-controls="sidebarMenu" aria-expanded="true" aria-label="Toggle sidebar"
                                            onClick={this.changeCols}
                                        >
                                            <span className='sidebar-span'>Menu</span>
                                            <i className="arrow right kvg-border"></i>
                                        </button>
                                    </div>
                                </div>

                                <div className="col-12 col-lg-8" id="largeCardCol">
                                    <div className="sidebar-inner-content">
                                        <SidebarTopHeader dataProvider={this.cmsDataProvider} assetId={this.cmsAssetId} />
                                        <div className="large-card">
                                            <DropZone name="droppable" />
                                            <div className='grid-card-wrapper'>
                                                <DropZone name="DragDropZone" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </main>


                <div className="kvg-footer">
                    <FooterNavigation dataProvider={this.cmsDataProvider} />
                </div>

            </div>
        )
    }
}
